import { PayloadAction } from "@reduxjs/toolkit";
import { put, call, all } from "redux-saga/effects";

import { Roles } from "config/security";
import { IKeyData } from "infrastructure";
import { notification } from "infrastructure/notification";
import { takeLatest } from "infrastructure/store/sagaEffects";
import { securityMessages } from "ui/screens/security/security.localization";
import { filterPickerData, IPickerSearchCriterion } from "ui/screens/security/shared/picker";

import { enterpriseActions } from "./Enterprise.actions";
import { getEnterprises } from "./Enterprise.api";
import { IEnterprisesResponse } from "./Enterprise.api.types";
import { IEnterprise } from "./Enterprise.state";

function* loadEnterprisesExecute({ payload }: PayloadAction<IKeyData<IPickerSearchCriterion<IEnterprise>>>) {
  try {
    const enterprisesResponse: IEnterprisesResponse[] = yield call(getEnterprises, {
      securityRoles: [Roles.PlexSecurityAdmin, Roles.SecurityAdmin],
      filter: payload.data.query.query
    });

    const enterprises: IEnterprise[] = filterPickerData(
      enterprisesResponse.map<IEnterprise>(e => {
        return {
          enterpriseId: e.enterpriseId,
          name: e.name
        };
      }),
      { ...payload.data, defaultValueProvider: e => e.name }
    );

    yield put(
      enterpriseActions.loadEnterprisesCompleted({
        id: payload.id,
        data: enterprises
      })
    );
  } catch (e) {
    yield put(
      enterpriseActions.loadEnterprisesFailed({
        id: payload.id,
        data: notification.error(e).useMessageId(securityMessages.error("loadEnterprisesFailed"))
      })
    );
  }
}

export function* enterprisesSaga() {
  yield all([yield takeLatest(enterpriseActions.loadEnterprises.toString(), loadEnterprisesExecute)]);
}
